export default __webpack_public_path__ + "static/media/9.db441ad5.webp";